import Config from '../config/config';
import axios from 'axios';

const { baseURL } = Config.API;

const create = async (formData) => {
  return axios({
    method: 'POST',
    baseURL,
    url: '/projects/create',
    data: formData
  });
};

const update = async (_id, formData) => {
  return axios({
    method: 'PATCH',
    baseURL,
    url: `/projects/update/${_id}`,
    data: formData
  });
};

const getProjects = async (queryParams) => {
  return axios({
    method: 'GET',
    baseURL,
    url: '/projects/getProjects',
    params: queryParams
  });
};

const deleteProjects = async (ids) => {
  return axios({
    method: 'DELETE',
    baseURL,
    url: '/projects/deleteProjects',
    data: {
      projectIds: ids
    }
  });
};

export default {
  create,
  update,
  getProjects,
  deleteProjects
};
